import React from "react";
import { Icon } from "@amzn/awsui-components-react";
import styles from "./style.module.scss";

const PncBadge: React.FC = () => (
  <span className={styles.pncBadge}>
    <Icon name="lock-private" size="small" />
    PNC
  </span>
);

export default PncBadge;
